import { createContext } from "react";

import type { CurrentNotice } from "src/api/Tmd.dtos";

/**
 * Exposes notices, loading state and provider-owned acknowledgement/dismissal actions.
 */
export type NoticeContextValue = {
    notices: readonly CurrentNotice[];
    loading: boolean;
    acknowledge: (noticeId: number) => Promise<void>;
    dismiss: (noticeId: number) => void;
};

/**
 * Provides notice data and actions, defaulting to an empty inactive state.
 *
 * Postconditions: Without a provider, acknowledgement fulfills without a request and dismissal
 * does nothing. Actual notice state changes belong to the provider.
 */
const NoticeContext = createContext<NoticeContextValue>({
    notices: [],
    loading: false,
    acknowledge: async () => undefined,
    dismiss: () => undefined
});

export default NoticeContext;
